import React, { useEffect } from "react";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import $ from "jquery";
import * as CallBackFunctions from "../functions/callBackFunctions";
import * as CommonFunctions from "../functions/commonFunctions";
import * as GC from "../../../../common/common";
import NumberInput from "../../../../common/component/NumberInput/NumberInput";

class AddMeasuresModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      naam: "",
      naamRequiredAlert: false,
      codeRequiredAlert: false,
      codeAlertText: "",
      code: GC.CodeAutoFill("MR"),
      omschrijving: "",
      bestekspost: "",
      rawhoofdcode: "",
      rawdeficode: "",
      eenheidsprijs: "",
      btwPercentage: "",
      percentage: "",
      active: true,
      kwaliteit: "",
      eenheid: "",
      patroonVoorkeur: "",
      patroonVoorkeurText: "",
      periodeVoorkeur: "",
      periodeVoorkeurText: "",
      grootboekNummer: "",
      discipline: "",
      disciplineText: "",
    };
    this.baseState = this.state;
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  resetForm = async () => {
    await this.setState(this.baseState);
    await this.setState({ code: GC.CodeAutoFill("MR") });
  };
  addParentFolder(childId) {
    var that = this;
    var parentId = $("#tree-parent-id").val();
    var model = { folder: parentId };

    omnimap
      .AddParentFolderAction(
        model,
        childId,
        window.$catalog_management_units_token
      )
      .then((result) => {
        console.log(result);
      });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    if (name === "patroonVoorkeur") {
      var index = event.nativeEvent.target.selectedIndex;
      this.setState({
        patroonVoorkeurText: event.nativeEvent.target[index].text,
      });
    }
    if (name === "periodeVoorkeur") {
      var index = event.nativeEvent.target.selectedIndex;
      this.setState({
        periodeVoorkeurText: event.nativeEvent.target[index].text,
      });
    }
    if (name === "discipline") {
      var index = event.nativeEvent.target.selectedIndex;
      this.setState({
        disciplineText: event.nativeEvent.target[index].text,
      });
    }

    this.setState({
      [name]: value,
    });

    if (value != "" && name == "naam") {
      this.setState({ naamRequiredAlert: false });
    }
  }

  async handleSubmit(event) {
    event.preventDefault();

    $("#cover-spin").show(0);

    this.state.naam == ""
      ? await this.setState({ naamRequiredAlert: true })
      : await this.setState({ naamRequiredAlert: false });
    this.state.code == ""
      ? await this.setState({
          codeRequiredAlert: true,
          codeAlertText: "required",
        })
      : await this.setState({ codeRequiredAlert: false, codeAlertText: "" });
    var model = {
      relationships: { definition: { code: "MAATREGEL" } },
      content: {
        algemeen: {
          kwaliteit: this.state.kwaliteit,
          btwpercentage: this.state.btwPercentage,
          actief: this.state.active,
          naam: this.state.naam,
          code: this.state.code,
          omschrijving: this.state.omschrijving,
          bestekspost: this.state.bestekspost,
          rawhoofdcode: this.state.rawhoofdcode.replaceAll(',', '.'),
          rawdeficode: this.state.rawdeficode.replaceAll(',', '.'),
          eenheidsprijs: this.state.eenheidsprijs.replaceAll(',', '.'),
          eenheid: this.state.eenheid,
          percentage: this.state.percentage.replaceAll(',', '.'),
          patroonvoorkeur: this.state.patroonVoorkeurText,
          periodevoorkeur: this.state.periodeVoorkeurText,
          patroonvoorkeurinput: {
            identification: this.state.patroonVoorkeur,
            display: [
              {
                path: "$.name",
                value: this.state.patroonVoorkeurText,
              },
            ],
          },
          periodevoorkeurinput: {
            identification: this.state.periodeVoorkeur,
            display: [
              {
                path: "$.name",
                value: this.state.periodeVoorkeurText,
              },
            ],
          },
        },
      },
    };

    let isUnique = true;
    let uniqueModel = {
      content: [
        {
          and_or: "AND",
          datatype: "STRING",
          key: "algemeen-code",
          values: [this.state.code],
        },
      ],
      definitions: [process.env.REACT_APP_CATALOG_MEASURES],
      sorting: [],
    };

    //** code isunique control.
    await omnimap
      .FillTableAction(uniqueModel, 1, window.$catalog_management_units_token)
      .then((result) => {
        if (result.data && result.data.length > 0) {
          isUnique = false;
          this.setState({
            codeRequiredAlert: true,
            codeAlertText: "is not unique",
          });
        }
      });

    if (
      this.state.naamRequiredAlert !== true &&
      this.state.codeRequiredAlert !== true &&
      isUnique === true
    ) {
      let result = await omnimap
        .SaveOrEditAction(
          model,
          "POST",
          "",
          window.$catalog_management_units_token
        )
        .catch((err) => {
          alert(err);
        });
      if (result.result.status === "OK") {
        this.addParentFolder(result.data["identification"]);
        window.$catalog_measures_newInsertId = result.data["identification"];

        const returnCallBack = await CallBackFunctions.MaatregelenSavedCallBack(
          window.$catalog_management_units_token
        );

        var grootboeknummerModel = {
          grootboeknummer: this.state.grootboekNummer,
        };
        var selectedIds = [result.data.identification];

        GC.sleep(2000).then(() => {
          GC.StartActivity(
            grootboeknummerModel,
            selectedIds,
            "4b2b5976-21e5-4810-8f58-adf0e8ecf481",
            "",
            window.$catalog_management_units_token
          );
        });

        var disciplineModel = {
          datum: "2020-12-01T12:00:00.001Z",
          discipline: {
            identification: this.state.discipline,
            display: [{ path: "$.name", value: this.state.disciplineText }],
          },
        };

        GC.sleep(2000).then(() => {
          GC.StartActivity(
            disciplineModel,
            selectedIds,
            "ac2c02c3-b545-42df-88dd-16abc83c01fc",
            "",
            window.$catalog_management_units_token
          );
        });
      }
    } else {
      $("#cover-spin").hide(0);
    }
  }

  componentDidMount() {
    var that = this;
    $(document).on("click", "#maatregelen_toevoegen", function () {
      $("#maatregelen_toevoegen_modal").modal("show");
      that.resetForm();

      CommonFunctions.GetColumnProperties("create");

      var model = {
        content: [
          {
            key: "algemeen-actief",
            and_or: "AND",
            values: [true],
            datatype: "BOOLEAN",
          },
        ],
        definitions: ["febe6c3b-abb3-4741-97c0-25fa510ec6aa"],
      };
      CommonFunctions.GetColumnPropertiesForModel(
        model,
        1,
        6,
        "create",
        "algemeen-patroonvoorkeur-identification",
        window.$catalog_management_units_token
      );
      var model = {
        content: [
          {
            key: "algemeen-actief",
            and_or: "AND",
            values: [true],
            datatype: "BOOLEAN",
          },
        ],
        definitions: ["06c1ff31-8693-4838-a58f-d0c1c1f3bdd9"],
      };
      CommonFunctions.GetColumnPropertiesForModel(
        model,
        1,
        6,
        "create",
        "algemeen-periodevoorkeur-identification",
        window.$catalog_management_units_token
      );

      GC.GetEntityList(
        process.env.REACT_APP_GROOTBOEK,
        1,
        500,
        CallBackFunctions.GrootboekCallbackForCreateMaat,
        window.$catalog_management_units_token
      );
      GC.GetEntityList(
        process.env.REACT_APP_CATALOG_DISCIPLINE,
        1,
        500,
        CallBackFunctions.DisciplineCallbackForCreateMaat,
        window.$catalog_management_units_token
      );
    });
  }

  render() {
    return (
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        id="maatregelen_toevoegen_modal"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Nieuwe maatregel</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <label
                className={
                  this.state.naamRequiredAlert
                    ? "modale-submit-alert-block"
                    : ""
                }
              >
                Naam *
              </label>
              <label
                className={
                  this.state.naamRequiredAlert
                    ? "modale-submit-alert-block"
                    : "modale-submit-alert-none"
                }
              >
                {"\u00A0"} required
              </label>
              <input
                id="maatregelen-naam"
                type="input"
                className="form-control"
                placeholder="Naam"
                name="naam"
                value={this.state.naam}
                onChange={this.handleInputChange}
                autoComplete="off"
              />
              <label
                className={
                  this.state.codeRequiredAlert
                    ? "modale-submit-alert-block"
                    : ""
                }
              >
                Code *
              </label>
              <label
                className={
                  this.state.codeRequiredAlert
                    ? "modale-submit-alert-block"
                    : "modale-submit-alert-none"
                }
              >
                {"\u00A0"} {this.state.codeAlertText}
              </label>
              <input
                id="maatregelen-code"
                type="input"
                className="form-control"
                placeholder="Code"
                name="code"
                value={this.state.code}
                onChange={this.handleInputChange}
                autocomplete="off"
              />
              <label>Omschrijving</label>
              <textarea
                id="maatregelen-omschrijving"
                type="input"
                className="form-control"
                placeholder="Omschrijving"
                rows="3"
                name="omschrijving"
                value={this.state.omschrijving}
                onChange={this.handleInputChange}
              ></textarea>
              <label>Bestekspost</label>
              <input
                id="maatregelen-bestekspost"
                type="input"
                className="form-control"
                placeholder="Bestekspost"
                name="bestekspost"
                value={this.state.bestekspost}
                onChange={this.handleInputChange}
                autocomplete="off"
              />
              <label>RAW Hoofdcode</label>
              <NumberInput
                id="maatregelen-rawhoofdcode"
                type="number"
                className="form-control"
                placeholder="RAW Hoofdcode"
                name="rawhoofdcode"
                value={this.state.rawhoofdcode}
                onChange={this.handleInputChange}
                autocomplete="off"
              />
              <label>RAW Deficode</label>
              <NumberInput
                id="maatregelen-rawdeficode"
                type="number"
                className="form-control"
                placeholder="RAW Deficode"
                name="rawdeficode"
                value={this.state.rawdeficode}
                onChange={this.handleInputChange}
                autocomplete="off"
              />
              <label>Kwaliteit</label>
              <select
                class="form-control"
                id="maatregelen-kwaliteit"
                name="kwaliteit"
                value={this.state.kwaliteit}
                onChange={this.handleInputChange}
              ></select>

              <label>Eenheidsprijs</label>
              <NumberInput
                id="maatregelen-eenheidsprijs"
                type="number"
                className="form-control"
                placeholder="Eenheidsprijs"
                name="eenheidsprijs"
                value={this.state.eenheidsprijs}
                onChange={this.handleInputChange}
                autocomplete="off"
              />
              <label>BTW percentage *</label>
              <select
                class="form-control"
                id="maatregelen-btw-percentage"
                name="btwPercentage"
                value={this.state.btwPercentage}
                onChange={this.handleInputChange}
              ></select>
              <label>Eenheid</label>
              <select
                class="form-control"
                id="maatregelen-eenheid"
                class="form-control"
                name="eenheid"
                value={this.state.eenheid}
                onChange={this.handleInputChange}
              ></select>

              <label>Percentage</label>
              <NumberInput
                id="maatregelen-percentage"
                type="number"
                className="form-control"
                placeholder="Percentage"
                name="percentage"
                value={this.state.percentage}
                onChange={this.handleInputChange}
                autocomplete="off"
              />

              <label>Patroon voorkeur</label>
              <select
                class="form-control"
                id="maatregelen-patroon-voorkeur"
                name="patroonVoorkeur"
                value={this.state.patroonVoorkeur}
                onChange={this.handleInputChange}
              ></select>

              <label>Periode voorkeur</label>
              <select
                class="form-control"
                id="maatregelen-periode-voorkeur"
                name="periodeVoorkeur"
                value={this.state.periodeVoorkeur}
                onChange={this.handleInputChange}
              ></select>
              <label>Discipline</label>
              <select
                class="form-control"
                id="maatregelen-discipline"
                name="discipline"
                value={this.state.discipline}
                onChange={this.handleInputChange}
              ></select>

              <label>Grootboek nummer</label>
              <select
                class="form-control"
                id="maatregelen-grootboek-nummer"
                name="grootboekNummer"
                value={this.state.grootboekNummer}
                onChange={this.handleInputChange}
              ></select>

              <label>Actief</label>
              <label className="switch">
                <input
                  id="maatregelen-active"
                  type="checkbox"
                  name="active"
                  defaultChecked
                  value={this.state.active}
                  onChange={this.handleInputChange}
                />
                <span className="slider-checkbox round" />
              </label>
              <br />
              <br />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                id="save-maatregelen"
                className="btn-modal"
                onClick={this.handleSubmit.bind(this)}
              >
                Verwerken
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddMeasuresModal;
